const localizers = {
  'loading.msg': () => `正在加载...`,
  'logon.message.msg': () => `需要身份验证。请输入有效的用户 ID 和密码。`,
  'logon.button.msg': () => `登录...`,
  'SASServer.logonError.msg': () => `无法登录服务器。`,
  'SASServer.genericError.msg': () => `无法访问服务器。`,
}
export default localizers;
